import RHFTextArea from './RHFTextArea.component';

export default RHFTextArea;
